require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photoshop-for-webdesign.json") })
        }
      }, "path---photoshop-for-webdesign");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photoshop-for-webdesign!./.cache/json/photoshop-for-webdesign.json
// module id = 555
// module chunks = 231608221292675